import moment from "moment";
import { API_URL } from "../config/config";
import { downloadRequest, getRequest, patchRequest } from "../utils/axiosUtils";
import { formatDate, formatStoredPhone, formattedAmount, getFilterQuery, getImageType, getStatusLabel } from "../utils/helperFunction";

export const fetchAllPaymentRequestList = async (
  {
  setRows,
  filterData = {},
  setRowCount,
  setLoading
}) => {
  try {
    setLoading && setLoading(true)
    const query = getFilterQuery(filterData)
    const url = `${API_URL}/wallet/admin/getAllPaymentRequest${query}`;

    const response = await getRequest({url});

    if (response.status >= 200 && response.status < 300 && response.data) {
       const pagination = response.data?.pagination
      const options = (response.data?.data || []).map((item,idx) => ({
         sNo: (pagination?.page-1)*pagination.limit + (idx+1),
        id: item._id,
        transactionId:item?.transactionId,
        studentId:item?.studentId || "-",
        StudentName:item?.user?.fullName || "-",
        phone: item?.user?.phone ? formatStoredPhone(item?.user?.phone) : '-', 
        email:item?.user?.email || "-",
        WithdrawalAmount: item?.amount ? formattedAmount(item?.amount) : '-',
        bankUpiDetails: item?.bankDetail?.bankName ?  `${item?.bankDetail?.bankName || ""} | ${item?.bankDetail?.accountNo || ""}` : '-',
        withdrawalMode:item?.creditType ? getImageType(item?.creditType)  :  '-',
        transType: item?.creditType ? getStatusLabel(item?.creditType)  :  '-',
        requestDate: item.createdAt ?  moment(item?.createdAt).format("DD/MM/YYYY") : '-',
        status:  item?.status ? getStatusLabel(item?.status)  :  '-',
        referralBonus:item?.amount ? formattedAmount(item?.amount) : '-',
      }));

      setRows(options);
      setRowCount && setRowCount(response.data?.pagination?.total || 0)
    } else {
      setRows([])
      throw new Error(`Unexpected response code: ${response.status}`);
    }
  } catch (error) {
    console.error("fetchAllPaymentReq  uestList error",error);
      setRows([])
     throw new Error(error?.response?.data?.message || 'Unknown error occurred');
  }finally{
    setLoading && setLoading(false)
  }
};

export const fetchPaymentRequestDetails = async (
  {
  transactionId,
  setDetails,
  setLoading
}) => {
  let details = {}
  try {
    if(!transactionId){
       throw new Error(`Transaction ID is required`);
    }
    setLoading && setLoading(true)
    const url = `${API_URL}/wallet/admin/getPaymentRequestDetails/${transactionId}`;

    const response = await getRequest({url});

    if (response.status >= 200 && response.data?.data) {
      const data = response?.data?.data
      const result = {
        id: data._id,
        bankHolderName: data?.bankDetail?.holderName || '-',
        bankAccountNo: data?.bankDetail?.accountNo || '-',
        bankIfscCode: data?.bankDetail?.ifscCode || '-',
        bankName: data?.bankDetail?.bankName || '-',
        bankAccountNickName: data?.bankDetail?.accountNickName || '-',
        bankBranchName: data?.bankDetail?.branchName || '-',
        bankAddress: data?.bankDetail?.bankAddress || '-',
        bankCity: data?.bankDetail?.city || '-',
        bankHolderPanNo: data?.bankDetail?.panNo || '-',
        bankAccountType: data?.bankDetail?.accountType || '-',
        studentId:data?.studentId || "-",
        studentName:data?.user?.fullName || "-",
        studentPhone:data?.user?.phone || "-",
        studentEmail:data?.user?.email || "-",
        studentJoined:data?.user?.createdAt ? moment(data?.user?.createdAt).format("DD/MM/YYYY") : "-",
        status:data?.status ? getStatusLabel(data?.status) : "-",
        withdrawalAmount: data?.amount ? formattedAmount(data?.amount) : '-',
        totalReferralAmt: data?.referrals ? formattedAmount(data?.referrals?.reduce((sum, s) => sum + (s?.earnAmount || 0), 0)) : '-',
        referrals: data?.referrals ? data?.referrals?.map(item => {
          return {
            name: item?.referredTo || "-",
            id:  item?.studentId || "-",
            course:  item?.course || "-",
            specialization:  item?.specialization || "-",
            university:  item?.university || "-",
            admissionDate:  item?.admissionDate || "-",
            bonus: item?.earnAmount ? formattedAmount(item?.earnAmount) :  "-",
          }
        }) : [],
      };
      details = result
    } else {
      throw new Error(`Unexpected response code: ${response.status}`);
    }
  } catch (error) {
    console.error("fetchAllPaymentReq  uestList error",error);
     throw new Error(error?.response?.data?.message || 'Unknown error occurred');
  }finally{
    setLoading && setLoading(false)
    setDetails(details)
  }
};

export const paymentRequestMarkAsPaid = async (
  {
  transactionId,
  setSaving
}) => {
  try {
    if(!transactionId){
       throw new Error(`Transaction ID is required`);
    }
    setSaving && setSaving(true)
    const url = `${API_URL}/wallet/admin/paymentRequestMarkAsPaid/${transactionId}`;

    const response = await patchRequest({url});

    if (response.status >= 200 && response.data?.data && response?.data?.success) {
      return response?.data
    } else {
      throw new Error(`Unexpected response code: ${response.status}`);
    }
  } catch (error) {
    console.error("paymentRequestMarkAsPaid  uestList error",error);
     throw new Error(error?.response?.data?.message || 'Unknown error occurred');
  }finally{
    setSaving && setSaving(false)
  }
};

export const paymentRequestMarkAsReject = async (
  {
  transactionId,
  setSaving,
  rejectReason,
}) => {
  try {
    if(!transactionId){
       throw new Error(`Transaction ID is required`);
    }
      if(!rejectReason){
       throw new Error(`Reject reason is required`);
    }
    setSaving && setSaving(true)
    const url = `${API_URL}/wallet/admin/rejectPaymentRequest/${transactionId}`;

    const response = await patchRequest({url,data:{rejectReason}});

    if (response.status >= 200 && response.data?.data && response?.data?.success) {
      return response?.data
    } else {
      throw new Error(`Unexpected response code: ${response.status}`);
    }
  } catch (error) {
    console.error("paymentRequestMarkAsReject  uestList error",error);
     throw new Error(error?.response?.data?.message || 'Unknown error occurred');
  }finally{
    setSaving && setSaving(false)
  }
};


export const downloadPaymentRequestList = async ({
  setDownloading,
  filterData={}
}) => {
  try {
    const query = getFilterQuery(filterData)
    const url = `${API_URL}/wallet/admin/getAllPaymentRequest${query}`

    setDownloading && setDownloading(true)
    const response = await downloadRequest({ url });

    if (response.status >= 200 && response.status < 300 && response.data) {
      const blob = new Blob([response?.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "payment_request.xlsx";
      link.click();
      window.URL.revokeObjectURL(url);
    } else {
      throw new Error(`Unexpected response code: ${response.status}`);
    }
  } catch (error) {
    console.error("downloadPaymentRequestList error", error);
    throw new Error(error?.response?.data?.message || `Failed to download`);
  } finally {
    setDownloading && setDownloading(false)
  }
};